import { render, staticRenderFns } from "./PageBooking.vue?vue&type=template&id=d64851c4&scoped=true&"
import script from "./PageBooking.vue?vue&type=script&lang=js&"
export * from "./PageBooking.vue?vue&type=script&lang=js&"
import style0 from "./PageBooking.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PageBooking.vue?vue&type=style&index=1&id=d64851c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64851c4",
  null
  
)

export default component.exports